<template>
    <div class="container-loading">
        <b-spinner :style="spinnerStyle" variant="primary" />
    </div>
</template>

<script>
export default {
    name: 'Loader',
    data() {
        return {
            spinnerStyle: {
                width: '3rem',
                height: '3rem',
            },
        }
    },
}
</script>

<style lang="scss" scoped>
.container-loading {
    width: 100vw;
    height: 100vh;
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    background: transparentize(#000, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
